/**
 * Sound file names for all game audio effects.
 * Sound files are located in packages/assets/sounds/
 */
export const SOUND_FILES = {
    // Trivia
    tick: 'tick.wav',
    correct: 'correct.wav',
    wrong: 'wrong.wav',
    'times-up': 'times-up.wav',
    'question-reveal': 'question-reveal.wav',
    // Board games
    'piece-place': 'piece-place.wav',
    capture: 'capture.wav',
    win: 'win.wav',
    draw: 'draw.wav',
    check: 'check.wav',
    checkmate: 'checkmate.wav',
    'your-turn': 'your-turn.wav',
    'king-promotion': 'king-promotion.wav',
    castling: 'castling.wav',
    promotion: 'promotion.wav',
    // Poker
    'card-deal': 'card-deal.wav',
    chips: 'chips.wav',
    fold: 'fold.wav',
    'all-in': 'all-in.wav',
    'win-pot': 'win-pot.wav',
    'table-tap': 'table-tap.wav',
    // Hot Takes
    'topic-reveal': 'topic-reveal.wav',
    'take-submitted': 'take-submitted.wav',
    'hot-take-sizzle': 'hot-take-sizzle.wav',
    'vote-cast': 'vote-cast.wav',
    'debate-clash': 'debate-clash.wav',
    'round-transition': 'round-transition.wav',
    'score-reveal': 'score-reveal.wav',
    'show-winner': 'show-winner.wav',
    'audience-gasp': 'audience-gasp.wav',
    'timer-tick-urgent': 'timer-tick-urgent.wav',
    // Tall Tales
    'campfire-crackle': 'campfire-crackle.wav',
    'story-chime': 'story-chime.wav',
    'quill-scratch': 'quill-scratch.wav',
    'story-tick': 'story-tick.wav',
    'voting-start': 'voting-start.wav',
    'truth-reveal': 'truth-reveal.wav',
    'fooled-someone': 'fooled-someone.wav',
    'got-fooled': 'got-fooled.wav',
    'round-score': 'round-score.wav',
    'campfire-victory': 'campfire-victory.wav',
    'fools-gold': 'fools-gold.wav',
    // Sea Strike
    'sonar-ping': 'sonar-ping.wav',
    'missile-launch': 'missile-launch.wav',
    explosion: 'explosion.wav',
    splash: 'splash.wav',
    'ship-sinking': 'ship-sinking.wav',
    'battle-horn': 'battle-horn.wav',
    'naval-victory': 'naval-victory.wav',
    'defeat-horn': 'defeat-horn.wav',
    'ship-place': 'ship-place.wav',
    'sea-strike-theme': 'sea-strike-theme.wav',
    // Word Rush (sound files not yet created)
    'word-rush-bg-loop': 'word-rush-bg-loop.wav',
    'timer-tension': 'timer-tension.wav',
    'letter-reveal': 'letter-reveal.wav',
    'category-pop': 'category-pop.wav',
    'go-chime': 'go-chime.wav',
    'answer-submit': 'answer-submit.wav',
    'timer-warning': 'timer-warning.wav',
    'answer-pop': 'answer-pop.wav',
    'duplicate-clash': 'duplicate-clash.wav',
    'unique-ding': 'unique-ding.wav',
    'points-coin': 'points-coin.wav',
    'round-swoosh': 'round-swoosh.wav',
    'new-leader': 'new-leader.wav',
    'final-round': 'final-round.wav',
    'victory-fanfare': 'victory-fanfare.wav',
    // Word Spies (sound files not yet created)
    'typewriter-click': 'typewriter-click.wav',
    'transmission-beep': 'transmission-beep.wav',
    'radio-static': 'radio-static.wav',
    'spy-card-select': 'spy-card-select.wav',
    'dossier-flip': 'dossier-flip.wav',
    'agent-found': 'agent-found.wav',
    'bystander-miss': 'bystander-miss.wav',
    'enemy-agent': 'enemy-agent.wav',
    'assassin-hit': 'assassin-hit.wav',
    'briefing-transition': 'briefing-transition.wav',
    'mission-success': 'mission-success.wav',
    'mission-failed': 'mission-failed.wav',
    'final-agent': 'final-agent.wav',
    // Hidden Roles
    'night-begins': 'night-begins.wav',
    'day-begins': 'day-begins.wav',
    'clock-chime': 'clock-chime.wav',
    'detective-investigate': 'detective-investigate.wav',
    'doctor-protect': 'doctor-protect.wav',
    'threat-attack': 'threat-attack.wav',
    'gavel-bang': 'gavel-bang.wav',
    'vote-accusation': 'vote-accusation.wav',
    'elimination-reveal': 'elimination-reveal.wav',
    'saved-by-doctor': 'saved-by-doctor.wav',
    'innocents-win': 'innocents-win.wav',
    'threats-win': 'threats-win.wav',
    'role-reveal': 'role-reveal.wav',
    'suspense-tick': 'suspense-tick.wav',
    'discussion-start': 'discussion-start.wav',
    'hr-voting-start': 'hr-voting-start.wav',
};
/**
 * Get the base URL for assets. Uses Vite's BASE_URL if available.
 * Falls back to '/' for non-Vite environments.
 */
export function getAssetBaseUrl() {
    // In Vite apps, import.meta.env.BASE_URL is available
    if (typeof import.meta !== 'undefined' && import.meta.env?.BASE_URL) {
        return import.meta.env.BASE_URL;
    }
    return '/';
}
/**
 * Get the full URL for a sound file, properly handling Vite's base path.
 */
export function getSoundUrl(name) {
    return `${getAssetBaseUrl()}sounds/${SOUND_FILES[name]}`;
}
/**
 * Legacy sound paths object for compatibility.
 * @deprecated Use getSoundUrl() for proper base path handling in Vite apps.
 */
export const SOUNDS = Object.fromEntries(Object.entries(SOUND_FILES).map(([key, file]) => [key, `/sounds/${file}`]));
//# sourceMappingURL=sounds.js.map